export function deepEqual<T>(object: T, object2: T): boolean {
  return JSON.stringify(object) === JSON.stringify(object2); // FIXME this isn't the greatest, but can be easily optimised
}
